// Auto-generated by generateMatrixResources.mjs — do not edit by hand.
// Regenerate with `pnpm --filter @unifyapps/i18n gen:matrix-locales` after a matrix
// production build. Read by ../backendMatrix.ts.

import type { ResourceKey } from 'i18next';

type LocaleResourceLoader = () => Promise<ResourceKey>;

type MatrixLocaleResources = Record<string, Record<string, LocaleResourceLoader>>;

export const matrixLocaleResources: MatrixLocaleResources = {
  ar: {
    'ai-agents': () => import('../locales/ar/ai-agents.json'),
    blocks: () => import('../locales/ar/blocks.json'),
    'code-snippet': () => import('../locales/ar/code-snippet.json'),
    common: () => import('../locales/ar/common.json'),
    connection: () => import('../locales/ar/connection.json'),
    connectors: () => import('../locales/ar/connectors.json'),
    copilot: () => import('../locales/ar/copilot.json'),
    filter: () => import('../locales/ar/filter.json'),
    'form-widgets': () => import('../locales/ar/form-widgets.json'),
    form: () => import('../locales/ar/form.json'),
    'generated/ConditionalAddButton': () =>
      import('../locales/ar/generated/ConditionalAddButton.json'),
    'generated/FilterActions': () => import('../locales/ar/generated/FilterActions.json'),
    'generated/const': () => import('../locales/ar/generated/const.json'),
    'generated/schema': () => import('../locales/ar/generated/schema.json'),
    'interfaces-matrix': () => import('../locales/ar/interfaces-matrix.json'),
    notifications: () => import('../locales/ar/notifications.json'),
    objects: () => import('../locales/ar/objects.json'),
    pipelines: () => import('../locales/ar/pipelines.json'),
    qrcode: () => import('../locales/ar/qrcode.json'),
    settings: () => import('../locales/ar/settings.json'),
    theme: () => import('../locales/ar/theme.json'),
    workflows: () => import('../locales/ar/workflows.json'),
    workspaces: () => import('../locales/ar/workspaces.json'),
  },
  de: {
    blocks: () => import('../locales/de/blocks.json'),
    'code-snippet': () => import('../locales/de/code-snippet.json'),
    common: () => import('../locales/de/common.json'),
    connection: () => import('../locales/de/connection.json'),
    connectors: () => import('../locales/de/connectors.json'),
    copilot: () => import('../locales/de/copilot.json'),
    cron: () => import('../locales/de/cron.json'),
    filter: () => import('../locales/de/filter.json'),
    'form-widgets': () => import('../locales/de/form-widgets.json'),
    form: () => import('../locales/de/form.json'),
    'generated/const': () => import('../locales/de/generated/const.json'),
    'generated/schema': () => import('../locales/de/generated/schema.json'),
    'interfaces-matrix': () => import('../locales/de/interfaces-matrix.json'),
    knowledge: () => import('../locales/de/knowledge.json'),
    'module-defs': () => import('../locales/de/module-defs.json'),
    notifications: () => import('../locales/de/notifications.json'),
    objects: () => import('../locales/de/objects.json'),
    qrcode: () => import('../locales/de/qrcode.json'),
    settings: () => import('../locales/de/settings.json'),
    theme: () => import('../locales/de/theme.json'),
    'workflow-agent': () => import('../locales/de/workflow-agent.json'),
    workflows: () => import('../locales/de/workflows.json'),
    workspaces: () => import('../locales/de/workspaces.json'),
  },
  en: {
    'ai-agents': () => import('../locales/en/ai-agents.json'),
    blocks: () => import('../locales/en/blocks.json'),
    'cm-editor': () => import('../locales/en/cm-editor.json'),
    'code-snippet': () => import('../locales/en/code-snippet.json'),
    common: () => import('../locales/en/common.json'),
    connection: () => import('../locales/en/connection.json'),
    connectors: () => import('../locales/en/connectors.json'),
    copilot: () => import('../locales/en/copilot.json'),
    cron: () => import('../locales/en/cron.json'),
    filter: () => import('../locales/en/filter.json'),
    'form-widgets': () => import('../locales/en/form-widgets.json'),
    form: () => import('../locales/en/form.json'),
    'generated/ConditionalAddButton': () =>
      import('../locales/en/generated/ConditionalAddButton.json'),
    'generated/FilterActions': () => import('../locales/en/generated/FilterActions.json'),
    'generated/const': () => import('../locales/en/generated/const.json'),
    'generated/schema': () => import('../locales/en/generated/schema.json'),
    'interfaces-matrix': () => import('../locales/en/interfaces-matrix.json'),
    knowledge: () => import('../locales/en/knowledge.json'),
    'module-defs': () => import('../locales/en/module-defs.json'),
    notifications: () => import('../locales/en/notifications.json'),
    objects: () => import('../locales/en/objects.json'),
    pipelines: () => import('../locales/en/pipelines.json'),
    qrcode: () => import('../locales/en/qrcode.json'),
    settings: () => import('../locales/en/settings.json'),
    skills: () => import('../locales/en/skills.json'),
    theme: () => import('../locales/en/theme.json'),
    'workflow-agent': () => import('../locales/en/workflow-agent.json'),
    workflows: () => import('../locales/en/workflows.json'),
    workspaces: () => import('../locales/en/workspaces.json'),
  },
  es: {
    'ai-agents': () => import('../locales/es/ai-agents.json'),
    blocks: () => import('../locales/es/blocks.json'),
    'code-snippet': () => import('../locales/es/code-snippet.json'),
    common: () => import('../locales/es/common.json'),
    connection: () => import('../locales/es/connection.json'),
    connectors: () => import('../locales/es/connectors.json'),
    copilot: () => import('../locales/es/copilot.json'),
    cron: () => import('../locales/es/cron.json'),
    filter: () => import('../locales/es/filter.json'),
    'form-widgets': () => import('../locales/es/form-widgets.json'),
    form: () => import('../locales/es/form.json'),
    'generated/ConditionalAddButton': () =>
      import('../locales/es/generated/ConditionalAddButton.json'),
    'generated/FilterActions': () => import('../locales/es/generated/FilterActions.json'),
    'generated/const': () => import('../locales/es/generated/const.json'),
    'generated/schema': () => import('../locales/es/generated/schema.json'),
    'interfaces-matrix': () => import('../locales/es/interfaces-matrix.json'),
    knowledge: () => import('../locales/es/knowledge.json'),
    'module-defs': () => import('../locales/es/module-defs.json'),
    notifications: () => import('../locales/es/notifications.json'),
    objects: () => import('../locales/es/objects.json'),
    pipelines: () => import('../locales/es/pipelines.json'),
    qrcode: () => import('../locales/es/qrcode.json'),
    settings: () => import('../locales/es/settings.json'),
    theme: () => import('../locales/es/theme.json'),
    'workflow-agent': () => import('../locales/es/workflow-agent.json'),
    workflows: () => import('../locales/es/workflows.json'),
    workspaces: () => import('../locales/es/workspaces.json'),
  },
  fr: {
    'ai-agents': () => import('../locales/fr/ai-agents.json'),
    blocks: () => import('../locales/fr/blocks.json'),
    'code-snippet': () => import('../locales/fr/code-snippet.json'),
    common: () => import('../locales/fr/common.json'),
    connection: () => import('../locales/fr/connection.json'),
    connectors: () => import('../locales/fr/connectors.json'),
    copilot: () => import('../locales/fr/copilot.json'),
    filter: () => import('../locales/fr/filter.json'),
    'form-widgets': () => import('../locales/fr/form-widgets.json'),
    form: () => import('../locales/fr/form.json'),
    'generated/ConditionalAddButton': () =>
      import('../locales/fr/generated/ConditionalAddButton.json'),
    'generated/FilterActions': () => import('../locales/fr/generated/FilterActions.json'),
    'generated/const': () => import('../locales/fr/generated/const.json'),
    'generated/schema': () => import('../locales/fr/generated/schema.json'),
    'interfaces-matrix': () => import('../locales/fr/interfaces-matrix.json'),
    notifications: () => import('../locales/fr/notifications.json'),
    objects: () => import('../locales/fr/objects.json'),
    pipelines: () => import('../locales/fr/pipelines.json'),
    qrcode: () => import('../locales/fr/qrcode.json'),
    settings: () => import('../locales/fr/settings.json'),
    theme: () => import('../locales/fr/theme.json'),
    workflows: () => import('../locales/fr/workflows.json'),
    workspaces: () => import('../locales/fr/workspaces.json'),
  },
  he: {
    common: () => import('../locales/he/common.json'),
    copilot: () => import('../locales/he/copilot.json'),
  },
  ru: {
    common: () => import('../locales/ru/common.json'),
    copilot: () => import('../locales/ru/copilot.json'),
  },
};
